module.exports = __webpack_public_path__ + "img/material-trading.1d8502d4.svg";